import React, { useEffect } from 'react'
import { useAppSelector, useAppDispatch } from 'app/hooks'
import {
    RootState,
    AppMetaData,
} from 'app/types'
import {
    Media,
    Message,
} from 'components'
import { useHistory } from 'react-router-dom'
import { getMediaLink } from 'helpers/media'
import * as fnc from 'helpers/fnc'
import { applyTheming } from 'actions/appActions'

interface BrokerPortalIndexProps {
    organizationLink: string
}

export function BrokerPortalIndex(props: BrokerPortalIndexProps) {
    const { organizationLink } = props
    const dispatch = useAppDispatch()
    const config = useAppSelector((state: RootState) => state.app.config)
    const organization = useAppSelector((state: RootState) => state.app.organization)
    const customDomain = useAppSelector((state: RootState) => state.app.customDomain)
    const media = useAppSelector((state: RootState) => state.app.media)
    const history = useHistory()

    // Apply theming for this organization
    useEffect(() => {
        applyTheming(() => ({ app: { config } }), dispatch, organization)
    }, [organization?.id, organization?.themeId, organization?.colorSchemeId, dispatch])

    // Get published apps for this organization
    const publishedApps = config.apps?.filter((app) => {
        if (!app.meta.published) return false
        if (!organization) return false
        return organization.apps?.includes(app.meta.id)
    }) || []

    function handleAppClick(app: AppMetaData) {
        const prefix = (!customDomain.organization && organizationLink) ? `/${organizationLink}` : ''
        history.push(`${prefix}/${app.link}/broker-portal`)
    }

    if (!organization) {
        return <div className="broker-portal-index">
            <Message type="error" message="Organization not found" />
        </div>
    }

    return <div id="broker-portal-index" className="broker-portal-index fadeIn">
        <div className="broker-portal-index-header">
            {organization.logoMediaId && organization.logoMediaId in media && <div className="broker-portal-logo">
                <img src={getMediaLink(media[organization.logoMediaId].link, { organization })} alt={organization.name} />
            </div>}
            <h1>Broker Portal</h1>
            <p>Select a project to access its broker portal</p>
        </div>

        <div className="broker-portal-index-grid">
            {publishedApps.length === 0 && <Message type="info" message="No projects are currently available" />}
            {publishedApps.map((app) => {
                const appMeta = app.meta
                return <div
                    key={appMeta.id}
                    className="broker-portal-project-card"
                    onClick={() => handleAppClick(appMeta)}
                >
                    {appMeta.mediaId && <div className="broker-portal-project-media">
                        <Media mediaId={appMeta.mediaId} />
                    </div>}
                    <div className="broker-portal-project-info">
                        <h3>{appMeta.name}</h3>
                        {appMeta.summary && <p>{appMeta.summary}</p>}
                        {appMeta.estCompletion && <span className="est-completion">Est. Completion: {appMeta.estCompletion}</span>}
                    </div>
                </div>
            })}
        </div>
    </div>
}
